import { Box, Button, Checkbox } from '@mui/material'
import React, { useEffect, useState } from 'react'
import LineInputV3 from '../../common/lineInputV3'
import { Item } from '../../common/snippets'
import DropDownOA from '../../common/dropDownOA'
import * as sx from '../../common/stylesInline/report_daily_branch'
import { focusElemnt, getInt, navigation1, navigation3 } from '../../common/helper'
import { ValidateAadhaar, pancardValidation } from './const'
import Lineinput from '../../common/lineinput'

export const DeliveryMemoBottom1 = (props) => {
  const { data = {}, methods = {}, updateAlertError  } = props
  const { bulkDeliveryCheck, reciverName, reciverPhone, getIdProof: receiverIdList, selectedRecIdType, ReIdNumber, selectedMOP } = data
  const { partyList, selectedParty, vehicleList, selectedVehicle, remarks, MOPList, loginData, selectedLrs } = data
  const { setBulkDeliveryCheck, setRecieverName, setReceiverPhone, setselectedRecIdType, setReIdNumber, setSelectedMOP } = methods
  const { setSelectedParty, setSelectedVehicle, setRemarks, bulkDeliver } = methods
  const handleIdProofInput = (e) => {
    let idValue = e.target.value;
    if (idValue !== '' && selectedRecIdType.IDProof === 'PAN Card') {
      if (pancardValidation(idValue)) {
        setReIdNumber(idValue)
      } else {
        setReIdNumber('')
        updateAlertError({ show: true, msg: 'Invalid PAN Card Number',close: resetValues(), nextId: 'memoDeliveryReceiverIdNumber' })
      }
    } else if (idValue !== '' && selectedRecIdType.IDProof === 'Aadhar Card') {
      if (ValidateAadhaar(idValue)) {
        setReIdNumber(idValue)
      } else {
        setReIdNumber('')
        setTimeout(()=>{
        updateAlertError({ show: true, msg: 'Invalid PAN Card Number', close: resetValues(), nextId: 'memoDeliveryReceiverIdNumber' })
        },100)
      }
    } else {
      if (idValue !== '') {
        setReIdNumber(idValue)
      }
    }
  }

  const resetValues = () => {
    setReIdNumber('')
    updateAlertError({ show: false, msg: '' })
    focusElemnt('memoDeliveryReceiverIdNumber')
  }
   
  return (
    <Box className="delivery-memo-bottom">
      <Box sx={{ ...sx.reportFlex,paddingLeft:'5px', justifyContent: 'start', flexWrap: 'nowrap', alignItems: 'center', height: '100%', paddingBottom:'10px' }}>
        <Box>
          <label htmlFor="" style={{ whiteSpace: 'nowrap' }}>
            <Checkbox
              id="memoBulkDelivery"
              onKeyDown={(e) => {
                navigation1(e, 'memomemoDeliveryReceiverAllLr', '')
              }}
              checked={bulkDeliveryCheck}
              onChange={(e) => {
                e.preventDefault()
              }}
            />
            Bulk Delivery
          </label>
        </Box>
        <Item className="input--wrapper" sx={sx.itemsx}>
          <LineInputV3
            onKeyDown={(e) => {
              navigation1(e, 'memoDeliveryReceiverPhone', 'memoTablerowCheck0')
            }}
            id="memoDeliveryReceiver"
            label="Delivery Received By"
            value={reciverName}
            onBlur={(e) => setRecieverName(e.target.value)}
          />
        </Item>
        <Item className="input--wrapper" sx={sx.itemsxGrow}>
          <LineInputV3
            onKeyDown={(e) => {
              navigation1(e, 'memoDeliveryReceiverIdType', 'memoDeliveryReceiver')
            }}
            id="memoDeliveryReceiverPhone"
            label="Receiver s Mob No"
            value={reciverPhone}
            filter={getInt}
            maxLength={loginData?.MobileNoULimit}
            onBlur={(e) => setReceiverPhone(e.target.value)}
          />
        </Item>
        <Item className="input--wrapper" sx={sx.itemsxGrow}>
          <DropDownOA
            id="memoDeliveryReceiverIdType"
            nextId="memoDeliveryReceiverIdNumber"
            prevId="memoDeliveryReceiverPhone"
            label="Select ID Proof"
            data={receiverIdList}
            defaultvalue={selectedRecIdType?.IDProof}
            value={selectedRecIdType?.IDProof}
            idKey={'IDProofid'}
            dataKey={'IDProof'}
            resetFlag={!bulkDeliveryCheck}
            onSelect={(val) => setselectedRecIdType(val)}
            width={'100%'}
            listWidth={'170px'}
            onSelResetVal={true}
          />
        </Item>
        <Item className="input--wrapper" sx={sx.itemsxGrow}>
          <Lineinput
           id="memoDeliveryReceiverIdNumber"
           onKeyDown={(e) => {
             navigation1(e, 'memoDeliveryMop', 'memoDeliveryReceiverIdType')
           }}
           label="ID Proof Number"
           value={ReIdNumber || ''}
           onBlur={(e) => { handleIdProofInput(e) }}
            onChange={(e) => setReIdNumber(e.target.value)}
          />
        </Item>
        <Item sx={sx.itemsx}>
          <DropDownOA
            id="memoDeliveryMop"
            nextId="memoDeliveryReceiverParty"
            prevId="memoDeliveryReceiverIdNumber"
            label="Mode of Payment"
            data={MOPList}
            idKey={'ModeID'}
            dataKey={'ModeName'}
            resetFlag={!bulkDeliveryCheck}
            defaultvalue={selectedMOP?.ModeName}
            value={selectedMOP?.ModeName}
            disabled={selectedLrs?.[0]?.PaymentTypeID===5||selectedLrs?.[0]?.PaymentTypeID===10}
            onSelect={(val) => 
              // handleSelectedMOP(val)
              setSelectedMOP(val)
            }
            listWidth={'170px'}
            onSelResetVal={true}
          />
        </Item>
        <Item sx={sx.itemsx}>
          <DropDownOA
            id="memoDeliveryReceiverParty"
            nextId="memoDeliveryVehicle"
            prevId="memoDeliveryMop"
            label="Select Party Name"
            data={partyList}
            dataKey={'Party'}
            idKey={'PartyID'}
            resetFlag={!bulkDeliveryCheck}
            defaultvalue={selectedParty?.Party}
            value={selectedParty?.Party}
            onSelect={(val) => setSelectedParty(val)}
            disabled={selectedMOP?.ModeName !== 'Credit'||selectedLrs?.[0]?.PaymentTypeID===5||selectedLrs?.[0]?.PaymentTypeID===10}
            listWidth={'170px'}
            onSelResetVal={true}
          />
        </Item>
        <Item sx={sx.itemsx} className="input--wrapper">
          <DropDownOA
            id="memoDeliveryVehicle"
            nextId="memoDeliveryRemarks"
            prevId="memoDeliveryReceiverParty"
            label="Vehicle Number"
            data={vehicleList}
            dataKey={`VehicleNo`}
            idKey={`VehicleID`}
            resetFlag={!bulkDeliveryCheck}
            defaultvalue={selectedVehicle?.VehicleNo || ""}
            value={selectedVehicle?.VehicleNo || ""}
            onSelect={(val) => setSelectedVehicle(val)}
            listWidth={'170px'}
            onSelResetVal={true}
          />
        </Item>
        <Item sx={sx.itemsx} className="input--wrapper">
          <LineInputV3
            id="memoDeliveryRemarks"
            onKeyDown={(e) => {
              navigation1(e, 'memoDeliveryAction', 'memoDeliveryVehicle')
            }}
            label="Remark if Any"
            value={remarks}
            onBlur={(e) => setRemarks(e.target.value)}
          />
        </Item>
        <Button
          id="memoDeliveryAction"
          onKeyDown={(e) => {
            navigation3(e, 'memoGenerate', 'memoDeliveryRemarks',()=>bulkDeliver());
          }}
          style={{ margin: '0' }}
          className="btn add-btn"
          variant="contained"
          color="error"
          onClick={bulkDeliver}
        >
          deliver
        </Button>
      </Box>
    </Box>
  )
}

export const DeliveryMemoBottom2 = (props) => {
  const { data = {}, methods = {} } = props
  const { brnchList, driverInfo, vehicleList } = data;
  const { bulkDeliveryCheck, brnchForDelivery, trnsfrVehicle, driverName, remark, loginData } = data
  const { bulkDeliverTwo, setBrnchForDelivery, setTrnsfrVehicle, setDriverName, setRemark } = methods
  const [branchListData, setBranchListData] = useState([])
  useEffect(() => {
    let newList = brnchList.filter((item) => item.BranchID !== loginData.intBranchID)
    setBranchListData(newList)
  }, [brnchList])
  return (
    <Box className="delivery-memo-bottom">
      <Box sx={{ ...sx.reportFlex,paddingLeft:'5px', justifyContent: 'start', flexWrap: 'nowrap', alignItems: 'center', height: '100%', paddingBottom:'10px' }}>
        <Box>
          <label htmlFor="" style={{ whiteSpace: 'nowrap' }}>
            <Checkbox
              id="memoBulkDelivery"
              onKeyDown={(e) => {
                navigation1(e, 'memoBrnchForDeliveryTransfer', '')
              }}
              checked={bulkDeliveryCheck}
              onChange={(e) => {
                e.preventDefault()
              }}
            />
            Bulk Delivery
          </label>
        </Box>
        <Item sx={sx.itemsxGrow}>
          <DropDownOA
            id="memoBrnchForDeliveryTransfer"
            nextId="memoTrnsfrByVehicleNo"
            prevId="memoTablerowCheck0"
            label="Branch For Delivery Transfer"
            width={'100%'}
            data={branchListData || []}
            dataKey={`BranchName`}
            idKey={`BranchID`}
            resetFlag={!bulkDeliveryCheck}
            defaultvalue={brnchForDelivery?.BranchName || ''}
            value={brnchForDelivery?.BranchName || ''}
            onSelect={(value) => {setBrnchForDelivery(value)}}
            onSelResetVal={true}
          />
        </Item>
        <Item sx={sx.itemsxGrow}>
          <DropDownOA
            id="memoTrnsfrByVehicleNo"
            nextId="memoDriverName"
            prevId="memoBrnchForDeliveryTransfer"
            label="Transfer By Vehicle No"
            width={'100%'}
            data={vehicleList || []}
            dataKey={`VehicleNo`}
            idKey={`VehicleID`}
            resetFlag={!bulkDeliveryCheck}
            defaultvalue={trnsfrVehicle?.VehicleNo || ''}
            value={trnsfrVehicle?.VehicleNo || ''}
            onSelect={(value) => setTrnsfrVehicle(value)}
            onSelResetVal={true}
          />
        </Item>
        <Item sx={sx.itemsxGrow}>
          <DropDownOA
            id="memoDriverName"
            nextId="memoTrnsfrRemark"
            prevId="memoTrnsfrByVehicleNo"
            label="Select Driver Name"
            width={'100%'}
            data={driverInfo || []}
            dataKey={`DriverConductorName`}
            idKey={`DriverConductorID`}
            resetFlag={!bulkDeliveryCheck}
            defaultvalue={driverName?.DriverConductorName || ''}
            value={driverName?.DriverConductorName || ''}
            onSelect={(value) => setDriverName(value)}
            onSelResetVal={true}
          />
        </Item>
        <Item sx={sx.itemsxGrow} style={{ width: '255px' }} className="input--wrapper">
          <LineInputV3
            id="memoTrnsfrRemark"
            onKeyDown={(e) => {
              navigation1(e, 'memoDeliveryTransfer', 'memoDriverName')
            }}
            label="Transfer Remarks if Any"
            value={remark}
            onBlur={(e) => setRemark(e.target.value)}
          />
        </Item>
        <Button
          id="memoDeliveryTransfer"
          onKeyDown={(e) => {
            navigation3(e, 'memoGenerate','memoTrnsfrRemark',()=>bulkDeliverTwo())
          }}
          style={{ margin: '0', width: '100%', maxWidth: '280px' }}
          className="btn add-btn"
          variant="contained"
          color="error"
          onClick={bulkDeliverTwo}
        >
          transfer
        </Button>
      </Box>
    </Box>
  )
}
